import { cn } from '@/lib/utils';

interface RunningManIconProps {
  className?: string;
  animate?: boolean;
}

export function RunningManIcon({ className, animate = false }: RunningManIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn("text-yellow-400", animate && "animate-bounce", className)}
      fill="currentColor"
    >
      {/* Classic AIM Running Man silhouette */}
      <circle cx="12" cy="4" r="3" />
      <path d="M8 8h8l-1 5-2-1v9h-2v-6h-2v6H7v-9l-2 1-1-5h4z" />
      <path d="M5 22l4-4M19 22l-4-4" strokeWidth="2" stroke="currentColor" fill="none" />
    </svg>
  );
}

// AIM Buddy icon component
export function BuddyIcon({ status = 'online', className }: { status?: 'online' | 'away' | 'offline', className?: string }) {
  const statusColors = {
    online: 'text-green-600 dark:text-green-400',
    away: 'text-yellow-500',
    offline: 'text-gray-400',
  };

  return (
    <svg
      viewBox="0 0 24 24"
      className={cn("w-4 h-4", statusColors[status], className)}
      fill="currentColor"
    >
      <circle cx="12" cy="6" r="4" />
      <path d="M12 12c-4 0-8 2-8 6v2h16v-2c0-4-4-6-8-6z" />
    </svg>
  );
}
